// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalAddEnvironmentVariant_wrapper__0-d9T","head":"ModalAddEnvironmentVariant_head__gftWK","content":"ModalAddEnvironmentVariant_content__-VxHo"};